export default __webpack_public_path__ + "static/media/citigo.5dae8052.png";